import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  TotalMeetingsCost,
  TopTimeConsumingMeetings,
  TimeSpent,
  TopMeetingParticipants,
} from "@client.components/Charts";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import TopChartFilters from "@client.components/TopChartFilters";
import NavigationTabs from "../NavigationTabs";
import {
  exportAsync,
  makeIsExportLoading,
  setDashboardError,
} from "../reducer";
import "../Dashboard.scss";
import { makeProfile } from "@client.pages/Login/reducer";

const DashboardTeam = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const filter = useSelector(makeFilter);
  const isExportLoading = useSelector(makeIsExportLoading);
  const profile = useSelector(makeProfile);

  const setPageError = useCallback(
    (err) => {
      dispatch(setDashboardError(err));
    },
    [dispatch]
  );

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.dashboard"));

    return () => {
      setPageError(null);
    };
  }, [t, setTopBarTitle, setPageError]);

  // eslint-disable-next-line no-unused-vars
  const { email, ...restFilter } = filter;

  return (
    <div className="dashboard page">
      <NavigationTabs />
      <div className="body">
        <TopChartFilters
          isExportLoading={isExportLoading}
          onExport={() => {
            dispatch(
              exportAsync({
                filter: restFilter,
                language: i18n.language,
                isCostIndexPresentation: profile.isCostIndexPresentation,
              })
            );
          }}
        />
        <div className="dashboard-content">
          <div className="charts">
            <div className="chart-grid">
              <TotalMeetingsCost
                isOwn={false}
                filter={restFilter}
                onError={setPageError}
              />
              <TopMeetingParticipants
                filter={restFilter}
                onError={setPageError}
              />
              <TopTimeConsumingMeetings
                filter={restFilter}
                onError={setPageError}
              />
              <TimeSpent filter={restFilter} onError={setPageError} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardTeam;
